// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__fCMjT","modal":"modal_modal__Nszx8","modalCloseIcon":"modal_modalCloseIcon__IlJ7c","absolute":"modal_absolute__DdVxW","title":"modal_title__Td4A0"};